__turbopack_context__.v({
  "banner": "styles-module__cVmA5a__banner",
  "cta": "styles-module__cVmA5a__cta",
  "text": "styles-module__cVmA5a__text",
});
